var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgManagerFree(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "24px",
    viewBox: "0 0 25 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u7A7A\u95F2\u4E2D") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u4F1A\\u6240\\u7BA1\\u7406",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u6253\\u4F4D\\u7BA1\\u7406",
    transform: "translate(-1053.000000, -531.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u798F\\u5229\\u6A21\\u5757\\u5907\\u4EFD-3",
    transform: "translate(232.000000, 182.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-8",
    transform: "translate(0.000000, 48.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u4E00\\u53F7\\u6253\\u4F4D\\u5907\\u4EFD-16",
    transform: "translate(724.400000, 222.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u9501\\u5B9A\\u4E2D\\u5907\\u4EFD",
    transform: "translate(79.000000, 69.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7A7A\\u95F2\\u4E2D",
    transform: "translate(18.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fillOpacity: 0,
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.61538462,19.5 L17.3846154,19.5 C17.3846154,20.3296875 16.6971154,21 15.8461538,21 L15.0769231,21 C14.2259615,21 13.5384615,21.6703125 13.5384615,22.5 L13.5384615,23.4375 C13.5384615,23.746875 13.2788462,24 12.9615385,24 L11.0384615,24 C10.7211538,24 10.4615385,23.746875 10.4615385,23.4375 L10.4615385,22.5 C10.4615385,21.6703125 9.77403846,21 8.92307692,21 L8.15384615,21 C7.30288462,21 6.61538462,20.3296875 6.61538462,19.5 Z",
    id: "\\u8DEF\\u5F84",
    fill: "#0052D9",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22,9.75 C22,13.228125 20.125,16.275 17.3125,18 L6.6875,18 C3.875,16.275 2,13.228125 2,9.75 C2,4.3640625 6.47596154,0 12,0 C17.5240385,0 22,4.3640625 22,9.75 Z M13.3413462,11.8078125 C14.2211538,11.8078125 14.9326923,11.1140625 14.9326923,10.25625 C14.9326923,9.58125 14.4855769,9.0234375 13.8701923,8.8078125 C14.3317308,10.0640625 13.1201923,11.2125 11.8557692,10.771875 C12.0769231,11.371875 12.6490385,11.8078125 13.3413462,11.8078125 Z M15.7019231,14.00625 C15.7019231,13.33125 15.2548077,12.7734375 14.6394231,12.5578125 C15.1009615,13.8140625 13.8894231,14.9625 12.625,14.521875 C12.8461538,15.121875 13.4182692,15.5578125 14.1105769,15.5578125 C14.9903846,15.5578125 15.7019231,14.859375 15.7019231,14.00625 Z M18.7788462,11.00625 C18.7788462,10.33125 18.3317308,9.7734375 17.7163462,9.5578125 C18.1778846,10.8140625 16.9663462,11.9625 15.7019231,11.521875 C15.9230769,12.121875 16.4951923,12.5578125 17.1875,12.5578125 C18.0673077,12.5578125 18.7788462,11.859375 18.7788462,11.00625 L18.7788462,11.00625 Z",
    id: "\\u5F62\\u72B6",
    fill: "#0052D9",
    fillRule: "nonzero"
  }))))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgManagerFree);
export default __webpack_public_path__ + "static/media/manager_free.9216b027bd57ff5a66917ae596a2b69e.svg";
export { ForwardRef as ReactComponent };